export default __webpack_public_path__ + "static/media/post_joan.66574bde.jpg";